import { auth } from '../../../firebase';

export async function createLeadFromCalculator(client, stage = 'Quoted') {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || window.location.origin;

  // Get auth token for company-scoped storage
  const currentUser = auth.currentUser;
  if (!currentUser) {
    return { success: false, message: 'Authentication required' };
  }

  const token = await currentUser.getIdToken(true);

  const res = await fetch(`${backendUrl}/api/leads/create-from-calculator`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ client, stage }),
  });

  if (!res.ok) {
    const error = await res.json().catch(() => ({}));
    return { success: false, message: error.detail || 'Failed to create lead' };
  }

  return await res.json();
}
